import { render, staticRenderFns } from "./deduction-sheet.vue?vue&type=template&id=1ce6b38e"
import script from "./deduction-sheet.vue?vue&type=script&lang=js"
export * from "./deduction-sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports